import {Component, OnInit} from '@angular/core';
import {LogisticDay} from '../../../../data/logistic-day';
import {LogisticRoutesService, SuggestionDay} from '../../../../data/logistic-routes.service';
import moment from 'moment/moment';
import {LogisticSuggestion} from '../../../../data/logistic-suggestion';
import {ProjectActivity} from '../../../../../project-misc/data/project/activity/project-activity';

class SortButton {
  title: string;
  sortBy: string;
}

@Component({
  selector: 'app-logistic-planning-week',
  templateUrl: './logistic-planning-week.component.html',
  styleUrls: ['./logistic-planning-week.component.scss']
})
export class LogisticPlanningWeekComponent implements OnInit {
  week: LogisticDay[]
  activities: ProjectActivity[]

  logisticSuggestion: LogisticSuggestion;

  nextWeekStart = moment().add(1, 'weeks').startOf('isoWeek').format('YYYY-MM-DD');
  nextWeekEnd = moment().add(1, 'weeks').endOf('isoWeek').format('YYYY-MM-DD');

  nextWeekStartFormatted = moment().add(1, 'weeks').startOf('isoWeek').format('MMMM D');
  nextWeekEndFormatted = moment().add(1, 'weeks').endOf('isoWeek').format('MMMM D');

  // nextWeekStart = moment().startOf('isoWeek').format('YYYY-MM-DD');
  // nextWeekEnd = moment().endOf('isoWeek').format('YYYY-MM-DD');
  //
  // nextWeekStartFormatted = moment().startOf('isoWeek').format('MMMM D');
  // nextWeekEndFormatted = moment().endOf('isoWeek').format('MMMM D');

  approveLoading = false;
  refreshLoading = false;

  loadingSpinner = false;

  sortButtons: SortButton[] = [
    {
      title: 'Suggested Date',
      sortBy: 'suggestedStartDate'
    },
    {
      title: 'Original Date',
      sortBy: 'startDate'
    },
    {
      title: 'Chosen Date',
      sortBy: 'chosenActivityDate'
    }
  ]

  chosenSortButton: SortButton;

  constructor(
    protected logisticRoutesService: LogisticRoutesService
  ) {
    this.chosenSortButton = this.sortButtons[0]
  }

  ngOnInit(): void {
    this.getSuggestions()

    this.logisticRoutesService.logisticSuggestionChangesSubj.subscribe(() => {

      this.activities.forEach(act => {
        act.chosenActivityDate = act.isDateLock ? act.startDate : act.suggestedStartDate
      })

      this.sortByDate()
    })
  }

  getSuggestions() {
    this.loadingSpinner = true;

    this.logisticRoutesService.getSuggestions(this.nextWeekStart, this.nextWeekEnd).subscribe(res => {
      this.logisticSuggestion = res;
      this.logisticRoutesService.serviceLogisticSuggestion = this.logisticSuggestion;

      this.activities = this.logisticSuggestion.activities

      this.activities.forEach(act => {
        act.chosenActivityDate = act.isDateLock ? act.startDate : act.suggestedStartDate
      })

      this.sortByDate()

      this.loadingSpinner = false;
    })
  }

  sortByDate() {
    const dateMap = new Map<string, ProjectActivity[]>();
    const dateArr: SuggestionDay[] = []
    const sortFieldName = this.chosenSortButton.sortBy

    this.activities.forEach(activity => {
      const dateString = moment(activity[sortFieldName]).format('YYYY-MM-DD')
      if (!dateMap.has(dateString)) {
        dateMap.set(dateString, [])
      }

      dateMap.get(dateString).push(activity)
    })

    dateMap.forEach((val, key) => {
      dateArr.push({
        title: key,
        activities: val
      })
    })

    this.week = dateArr.sort((a, b) => {
      return new Date(a.title).getTime() - new Date(b.title).getTime();
    })
  }


  approveSuggestions() {
    this.approveLoading = true;

    this.logisticRoutesService.acceptLogistic(this.nextWeekStart, this.nextWeekEnd).subscribe(() => {
      this.approveLoading = false;
    })
  }

  reCalculate() {
    this.refreshLoading = true;
    this.logisticSuggestion.status = 'RUNNING';

    this.logisticRoutesService.refreshLogistic(this.nextWeekStart, this.nextWeekEnd).subscribe(() => {
      this.refreshLoading = false;
    })
  }
}
